import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { SIZE_OPTIONS } from "../consts";

var tooltipSize = function tooltipSize(_ref) {
  var _sizes;

  var size = _ref.size;
  var sizes = (_sizes = {}, _defineProperty(_sizes, SIZE_OPTIONS.SMALL, "240px"), _defineProperty(_sizes, SIZE_OPTIONS.MEDIUM, "380px"), _sizes);
  return sizes[size];
};

export default tooltipSize;